import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { TypeImageService } from '../type-image.service';
import { finalize } from 'rxjs';
import { helper } from 'src/environments/helper';

@Component({
  selector: 'app-add-type-image',
  templateUrl: './add-type-image.component.html',
  styleUrls: ['./add-type-image.component.scss'],
})
export class AddTypeImageComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;
  helper = helper;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    width: new FormControl('', Validators.required),
    height: new FormControl('', Validators.required),
  });

  constructor(
    private dialogRef: MatDialogRef<AddTypeImageComponent>,
    private typeImageService: TypeImageService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.typeImageService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const imageTypeData = {
      name: this.form.get('name')?.value,
      width: this.form.get('width')?.value,
      height: this.form.get('height')?.value,
    };
    this.typeImageService
      .addImageType(imageTypeData)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
